import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=5a6e1ac4&scoped=true"
import script from "./ModalBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=5a6e1ac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e1ac4",
  null
  
)

export default component.exports